export const NonVolatileText = 'Non- Volatility Trading Options Holders'
export const NonVolatileTextMobile  = 'Non-Volatility Trading Options Holders'


export const HolderText = "Holder"

export const AmountText= "Amount"

export const Change = "CHANGE"

export const Asof = "AS OF"

export const mobileChange = "Change"

export const mobileAsof = "As of"


// WEBPACK FOOTER //
// ./src/components/Modals/Holders Modal/constants.js